import { render, staticRenderFns } from "./ReserveTransfers.vue?vue&type=template&id=2c58a7f2&"
import script from "./ReserveTransfers.vue?vue&type=script&lang=js&"
export * from "./ReserveTransfers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports